import React from 'react';
import {Divider, Stack, Typography, capitalize} from '@mui/material';

import {StyledCardContent, StyledTypography} from './styles';
import {OdontoRecommendationsProps} from './types';

export function OdontoRecommendations({
	subheader,
	hasDivider,
	recommendations,
	noPadding,
}: OdontoRecommendationsProps) {
	return (
		<StyledCardContent $noPadding={noPadding}>
			{hasDivider ? <Divider sx={{my: 2}} /> : null}
			<Stack sx={{gap: 2}}>
				<Typography variant="subheader">{subheader}</Typography>
				{recommendations.map((item, index) => (
					<StyledTypography key={index} variant="body2">
						{capitalize(item.toLowerCase())}
					</StyledTypography>
				))}
			</Stack>
		</StyledCardContent>
	);
}
